// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonToggleGroupLarge = 4;
var ButtonToggleGroupMedium = 4;
var ButtonToggleGroupSmall = 4;
var ButtonDefault = 4;
var ModalDefault = 4;
var BorderRadiusSemanticsAll = {
  ButtonDefault: ButtonDefault,
  ButtonToggleGroupLarge: ButtonToggleGroupLarge,
  ButtonToggleGroupMedium: ButtonToggleGroupMedium,
  ButtonToggleGroupSmall: ButtonToggleGroupSmall,
  ModalDefault: ModalDefault
};

export { BorderRadiusSemanticsAll, ButtonDefault, ButtonToggleGroupLarge, ButtonToggleGroupMedium, ButtonToggleGroupSmall, ModalDefault, BorderRadiusSemanticsAll as default };
